import React from "react";
import Alert from "react-bootstrap/Alert";

class FinalStep extends React.Component {
  render() {
    if (this.props.internal) {
      return (
        <Alert variant="secondary">
          <Alert.Heading>¡Solicitud Exitosa!</Alert.Heading>
          <h5>{this.props.message}
          </h5>
        </Alert>
      )
    } else {
      return (
        <div className="card card-signin my-5 col-sm-6 border-left-0">
          <div className="card-body">
            <h1 className="card-title text-center">{this.props.title}</h1>
            <Alert variant="success">
              <Alert.Heading>¡Solicitud Exitosa!</Alert.Heading>
              <h5>{this.props.message}
              </h5>
            </Alert>
          </div>
        </div>
      )
    }

  }
}

export default FinalStep;
